// components/business/BusinessCardMobile.tsx
import type { Business } from "@/lib/types";
import React from "react";
import BusinessCardOneScreen from "./BusinessCardOneScreen";
import type { BusinessCardActionHandler } from "./usePublicBusinessCardActions";

type Props = {
  business: Business;
  onShare?: BusinessCardActionHandler;
  onSave?: BusinessCardActionHandler;
  onDownload?: BusinessCardActionHandler;
};

export default function BusinessCardMobile({
  business,
  onShare,
  onSave,
  onDownload,
}: Props) {
  return (
    <BusinessCardOneScreen
      business={business}
      onShare={onShare}
      onSave={onSave}
      onDownload={onDownload}
    />
  );
}
